import type { JSX } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";

import { ProfilerOffToolbar } from "./ProfilerOffToolbar";
import { ProfilerToolbar } from "./ProfilerToolbar";
import {
  type ProfilerToolbarDataProps,
  profilerToolbarDataSchema,
} from "./ProfilerToolbar.schema";
import { PROFILER_TOOLBAR_TAG_NAME } from "./constants";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    [PROFILER_TOOLBAR_TAG_NAME]: {
      props: ProfilerToolbarDataProps;
      handle: undefined;
    };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-profiler-toolbar": HTMLElement;
  }
}

function RWCProfilerToolbar({
  token,
  traceId,
}: ProfilerToolbarDataProps): JSX.Element {
  return token ? (
    <ProfilerToolbar token={token} traceId={traceId} />
  ) : (
    <ProfilerOffToolbar />
  );
}

componentManager.register(
  rwc(PROFILER_TOOLBAR_TAG_NAME, {
    component: RWCProfilerToolbar,
    dataSchema: profilerToolbarDataSchema,
  }),
);
